<template>
  <div class="flex-grow-1 flex-column d-flex justify-center align-center">
    <div class="calendar-loader__wrapper overlay-base" v-if="redirecting">
      <div class="calendar-loader__overlay overlay-base"></div>
      <div class="calendar-loader__content">
        <v-progress-linear indeterminate></v-progress-linear>
        <div class="text-center mt-3">Redirecting to Carrier Booking Portal...</div>
      </div>
    </div>
    <template v-if="!token">
      <p class="text-h6 d-block">
        <span class="error--text">ERROR: No Auth Token Provided.</span>
      </p>
    </template>
    <template v-else>
      <div v-if="loading" class="align-self-stretch text-center">
        <p class="mb-4 text-h6">Logging in ...</p>
        <v-progress-linear color="secondary" indeterminate loading="loading" rounded height="8">
        </v-progress-linear>
      </div>
      <div v-if="error" class="text-center">
        <span class="error--text text-h6">{{ error }}</span>
        <a href="https://carrier.opendock.com/app/auth/warehouse-search" class="d-block"
          >Back to Opendock</a
        >
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      token: null,
      warehouseId: null,
      loading: true,
      error: false,
      appointmentId: null,
      bypassCustomBookingUrl: false,
      redirecting: true
    };
  },
  methods: {
    async setWarehouseFromUrlParam() {
      await this.$store
        .dispatch('Warehouses/getWarehouseById', this.warehouseId)
        .then(async warehouse => {
          if (warehouse) {
            this.$store.commit('App/setWarehouse', warehouse);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sso() {
      this.$store.commit('Auth/setAccessToken', this.token);
      this.$store
        .dispatch('Auth/getMe', false)
        .then(async () => {
          localStorage.setItem('access_token', this.token);
          if (!this.$store.getters['Auth/isAllowed']) {
            await this.$router.replace({ name: 'notAllowed' });
          } else {
            await this.setWarehouseFromUrlParam();
            if (this.$warehouse?.customBookingUrl && !this.bypassCustomBookingUrl) {
              this.redirecting = true;
              window.location = this.getCustomBookingUrl(this.$warehouse, this.token);
            } else {
              let path = `/warehouse/${this.warehouseId}`;
              path += this.appointmentId ? `/appointments/${this.appointmentId}` : '';
              if (this.bypassCustomBookingUrl) {
                path += '?defaultUi=1';
              }
              await this.$router.replace({ path: path });
            }
          }
        })
        .catch(error => {
          this.error = 'There was an error logging in';
          if (error?.response?.data?.message) {
            this.error = `${this.error}: ${error.response.data.message}`;
          }
          this.loading = false;
        });
    }
  },
  mounted() {
    this.sso();
  },
  created() {
    this.token = this.$route.query.token;
    this.warehouseId = this.$route.query.warehouseId;
    this.appointmentId = this.$route.query.appointmentId;
    this.bypassCustomBookingUrl =
      this.$route.query.defaultUi === 'true' || this.$route.query.defaultUi === '1';
  }
};
</script>
